module.exports = __webpack_public_path__ + "catalog/items/naspo/naspofront.png";